import React from "react";
import styles from "./Privacy.module.css";

export default function Privacy() {
  return (
    <div className={styles.container}>
      <h1>Política de Privacidad</h1>

      <section>
        <h2>1. Responsable del tratamiento</h2>
        <p>
          Medicina Total (medicinatotal91@gmail.com) actúa como responsable del
          tratamiento de los datos personales que recopilamos.
        </p>
      </section>

      <section>
        <h2>2. Datos que recopilamos</h2>
        <ul>
          <li>Correo electrónico</li>
        </ul>
      </section>

      <section>
        <h2>3. Finalidad del tratamiento</h2>
        <ul>
          <li>Gestión de cuentas y autenticación.</li>
          <li>Entrega de cursos y seguimiento de progreso académico.</li>
          <li>Envío de comunicaciones informativas y académicas.</li>
        </ul>
      </section>

      <section>
        <h2>4. Base legal</h2>
        <p>
          Tratamos tus datos con tu consentimiento expreso y para la ejecución del
          servicio de acceso a los cursos.
        </p>
      </section>

      <section>
        <h2>5. Destinatarios</h2>
        <p>
          No compartimos tus datos personales con terceros salvo que sea necesario
          para el funcionamiento de la plataforma (por ejemplo, servicios de hosting o email).
        </p>
      </section>

      <section>
        <h2>6. Seguridad</h2>
        <p>
          Empleamos cifrado SSL, controles de acceso y otras medidas para proteger
          tu información personal.
        </p>
      </section>

      <section>
        <h2>7. Conservación</h2>
        <p>
          Conservamos tus datos mientras tu cuenta esté activa o hasta que solicites
          su eliminación.
        </p>
      </section>

      <section>
        <h2>8. Derechos del usuario</h2>
        <p>
          Podés ejercer tus derechos de acceso, rectificación, supresión, oposición,
          portabilidad o limitación enviando un correo a{" "}
          <a href="mailto:medicinatotal91@gmail.com">medicinatotal91@gmail.com</a>.
        </p>
      </section>

      <section>
        <h2>9. Uso de cookies</h2>
        <p>
          Utilizamos cookies esenciales para el funcionamiento de la plataforma. No
          realizamos seguimiento publicitario de terceros. Podés gestionar cookies
          desde la configuración de tu navegador.
        </p>
      </section>

      <section>
        <h2>10. Cambios en esta política</h2>
        <p>
          Esta política podrá ser actualizada para reflejar cambios legales o técnicos.
          Te notificaremos si son cambios relevantes.
        </p>
      </section>
    </div>
  );
}
